const errorCategory = (axios) => {
  return {

    getAll: () => axios.get('/ErrorCategory'),

  };
};

export default errorCategory;
